import { useTranslation } from 'next-i18next'
// Libs
import styled, { css } from 'styled-components'
import { useState } from 'react'
import NumberFormat, { NumberFormatValues } from 'react-number-format'

// Comps.
import { Section } from '../Section'
import { icons } from '../../utils'
import { previewEarningsCalculatorSectionStyles } from './previewEarningsCalculatorSectionStyles'
import { H1 } from '../H1'
import { P } from '../P'
import { Hyperlink } from '../Hyperlink'
import { calculateApplicationFee, toDollarString } from '../../utils/money'
import { MoneyInput } from '../Inputs/MoneyInput'

// Defs
interface Props {
  className?: string
}

// Styles
const Container = styled(Section)`
  ${previewEarningsCalculatorSectionStyles}
`

export const PreviewEarningsCalculatorSection: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props
  const { className } = props

  // Local State
  const [price, setPrice] = useState(undefined)

  // calc
  const displayMargin = toDollarString(price)

  // Func
  const onValueChange = (value: NumberFormatValues) => {
    const floatValue = value?.floatValue
    setPrice(calculateApplicationFee(floatValue))
  }

  // ..
  return (
    <Container
      className={`PreviewEarningsCalculatorSection ${className || ''}`}>
      {/* Coloured Background */}
      <div className="half-background" />

      {/* Image box on left */}
      <div className="cell left">
        <div className="image-box">
          <img src={'/images/paidevents-earnings-left.jpg'} />
        </div>
      </div>

      {/* Text and the calc  */}
      <div className="cell right">
        <H1>
          {t(`Earnings`, `Earnings`)}
          <br /> {t(`calculator`, `calculator`)}
        </H1>
        <P className="detail">
          {t(
            `PreviewEarningsCalculatorSection-604548501`,
            `Get the full picture you need to decide on your ticket price.`,
          )}
        </P>
        <P className="detail">
          {t(
            `PreviewEarningsCalculatorSection-245281596`,
            `Set the price you have in mind *`,
          )}
        </P>
        <P className="detail calc">
          <b>{t(`USD`, `USD`)}</b> <img src={icons.usaFlagEmoji} alt="USD" />{' '}
          <MoneyInput onValueChange={onValueChange} />{' '}
          <span className={'new-line-text'}>
            {t(`After`, `After`)}{' '}
            <Hyperlink href="/terms" newTab={true}>
              {t(`fees`, `fees`)}
            </Hyperlink>
            {t(
              `PreviewEarningsCalculatorSection-384125091`,
              ` your net per-ticket return is estimated to be around `,
            )}
            <b>{displayMargin}</b>.
          </span>
        </P>
      </div>
    </Container>
  )
}
